import { Theme } from "@mui/material";
import { ModelType } from "../../API";
import { ServiceTypeEnum } from "../../pages/model-manager/variables/modelManager";

export const DEFAULT_LIMIT_COUNT = 100;

export const HV_PAGE_SIZE = 25;

export const DEFAULT_COLUMN_HEADER_HEIGHT = 40;

export const DEFAULT_MEDIA_HEIGHT = "448px";

export const ONLINE_STATUS_THRESHOLD_MS = 900000; // 15 min

export const LON_LAT_NAME_PATTERN = /^-?[0-9]+(\.[0-9]+)?$/;

export const SIMPLE_NAME_PATTERN = /^[A-Za-z0-9 -]+$/;

export const ZONE_NAME_PATTERN = /^[a-zA-Z0-9\-_. @#$%&*!]+(?<![\\/:*?"<>|])$/;

export const PAN_TILT_PATTERN = /^(?!-\.|\.-|\.)(?:-?\d*(?:\.\d{0,2})?|)$/;

export const IP_MASK_PATTERN =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const Z_INDEX_PRIORITY = {
  HEADER: 5,
  LEFT_BAR: 3,
  LEFT_BAR_COLLAPSE_ICON: 4,
  FULL_PAGE_LOADER: 5,
  MODEL_SETTINGS: 10,
};

export const DEFAULT_DEVICE_PASSWORD = "admin:ccai1CCAI";

export const STATISTICS_BOX_HEIGHT = "315px";

export const modelToServiceMap: Record<ModelType, ServiceTypeEnum> = {
  [ModelType.gasleak]: ServiceTypeEnum.GAS_LEAK,
  [ModelType.liquidleak]: ServiceTypeEnum.LIQUID_LEAK,
  [ModelType.hardhat]: ServiceTypeEnum.HARD_HAT,
  [ModelType.agg]: ServiceTypeEnum.GATE_GUARD,
  [ModelType.tlm]: ServiceTypeEnum.TANK_LEVEL,
  [ModelType.fire]: ServiceTypeEnum.FIRE,
  [ModelType.smoke]: ServiceTypeEnum.SMOKE,
  [ModelType.ss]: ServiceTypeEnum.SAFETY_AND_SECURITY,
  [ModelType.firesmoke]: ServiceTypeEnum.FIRE_SMOKE,
  [ModelType.security]: ServiceTypeEnum.PEOPLE_AND_VEHICLE,
  [ModelType.peopleandvehicle]: ServiceTypeEnum.PEOPLE_AND_VEHICLE,
  [ModelType.safety]: ServiceTypeEnum.GAS_LEAK,
  [ModelType.vehicle]: ServiceTypeEnum.VEHICLE,
  [ModelType.people]: ServiceTypeEnum.PEOPLE,
};

export const DEFAULT_MEDIA_ICON_STYLES = {
  width: "100px",
  height: "75px",
  overflow: "hidden",
  borderRadius: "8px",
  objectFit: "fill",
  border: (theme: Theme) =>
    `1px solid ${theme.palette.otherOutlineBorder.main}`,
  background: (theme: Theme) =>
    `linear-gradient(180deg, 
      ${theme.palette.otherOutlineBorder.main} 0%, 
      ${theme.palette.otherElevation.main} 50%,
      ${theme.palette.otherOutlineBorder.main} 100%)`,
  backgroundSize: "100% 200%",
  animation: "shimmer 3s ease-in infinite",
};
